import React from 'react';
import { usePlatformTenant } from '../../contexts/PlatformTenantContext';

interface TenantLogoProps {
  className?: string;
  fallbackSrc?: string;
}

/**
 * TenantLogo - Displays the tenant's custom logo or falls back to default
 * 
 * The logo URL is stored in platform_tenants.branding_config.logo_url
 */
export const TenantLogo: React.FC<TenantLogoProps> = ({ 
  className = 'h-6 w-auto object-contain',
  fallbackSrc = '/faces_black_logo.png'
}) => {
  const { platformTenant } = usePlatformTenant();
  
  // Extract logo_url from branding_config if available
  const logoUrl = platformTenant?.branding_config?.logo_url || fallbackSrc;
  const companyName = platformTenant?.company_name || 'Platform';
 
  return (
    <img 
      src={logoUrl}
      alt={`${companyName} Logo`}
      className={className}
      onError={(e) => {
        // Fallback to default logo if custom logo fails to load
        const target = e.target as HTMLImageElement;
        if (target.src !== fallbackSrc) {
          target.src = fallbackSrc;
        }
      }}
    />
  );
};
